import * as React from 'react';
export const nbocSvg = React.forwardRef(function nbocSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F52F1D',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm5.19 22.93 8.11-2c.37-.08.64-.13.9-.04.22.08.38.29.53.48l2.5 3.16c.14.2.3.4.5.48.28.1.55.04.92-.04l8.09-2V9.05l-8.11 2c-.37.08-.64.13-.91.04-.2-.08-.37-.29-.52-.48l-2.5-3.16c-.14-.2-.3-.4-.51-.48-.27-.1-.54-.04-.9.04l-8.1 2v13.92z',
      }),
    ),
  );
});
nbocSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var nboc = {
  category: 'brand',
  colorable: false,
  name: 'nboc',
  svg: nbocSvg,
};
